module.exports = __webpack_public_path__ + "assets/4c8ddc8c99e247a0ea33c82f0d9f3e0e.mp3";